<template>
  <div class="page page-my-data content">
    <h1 class="page__title">{{ t('myData.menuTitle') }}</h1>

    <Personalize />

    <ContractData />
  </div>
</template>

<script setup>
  import ContractData from '@/components/settings/ContractData.vue'
  import LinkButton from '@/components/LinkButton.vue'
  import Personalize from '@/components/settings/Personalize.vue'
  import { useStrings } from '@/composables/useStrings.ts'
  import { useAuthStore } from '@/stores/useAuthStore'
  import { useFormsStore } from '@/stores/useFormsStore'
  import { useSettingsStore } from '@/stores/useSettingsStore'
  import { computed, ref } from 'vue'

  const { t } = useStrings()

</script>

<style lang="scss" scoped>
  .page {
    max-width: $content-page-width;
  }

</style>
